import { CreatePersonForm } from '~/pages/person/components/create-person-form';
import { Schema } from '~/pages/person/components/create-person-form.schema';
import { useUpdatePersonMutation } from '~/pages/person/mutations';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { usePersonQuery } from '~/pages/person/queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(() => {
  const mutation = useUpdatePersonMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { data } = usePersonQuery(id);

  async function handleSubmit(payload: Partial<Schema>) {
    const { data } = await mutation.mutateAsync({
      ...payload,
      club: payload.club?.[1] ?? undefined,
      id,
    });

    navigate(`../${data.id}`);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera lyftare" />

      <PageLayout.Section>
        <CreatePersonForm
          defaultValues={{
            club: [data.club.name, data.club.id],
            first_name: data.first_name,
            last_name: data.last_name,
            ssn: data.ssn ?? '',
            is_para: data.is_para,
            is_ifn: data.is_ifn,
          }}
          onSubmit={handleSubmit}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
